export const engagementAppGroupIdSurveys = "/engagement/:app_group_id/surveys";
